<style lang="less" scoped>
.app-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
}
.sidebar-container {
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
  background-color: #001529;
  border-right: none;
}

.app-el-main {
  flex-basis: 0;
  padding: 0;
}
.main-container {
  background-color: #f0f2f5;
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.copyright {
  margin-top: 20px;
  background-color: #f0f2f5;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 18px 0;
  svg {
    margin: 0 3px;
  }
}
</style>

<template>
  <el-container :class="classObj">
    <sidebar class="sidebar-container" />
    <el-main class="app-el-main">
      <div class="main-container">
        <navbar />
        <app-main />
        <div class="copyright">
          <span><a style="color: rgba(0, 0, 0, 0.45);margin-right: 5px" href="https://beian.miit.gov.cn/">沪ICP备 14020594号-5</a></span>
          <el-tag type='danger' style="margin-right: 5px">
            {{config.envTag || '测试站'}}
          </el-tag>
          <span>Copyright</span>
          <icon name="copyright" /> 2018 <span>北京兴长信达科技发展有限公司</span>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import config from '@/config'
import { actionClient } from '@/api'

export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  data() {
    return {
      timer: null,
      config
    }
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        'app-wrapper': true
      }
    }
  },
  mounted() {
    // let { onlyAllowRefundOrder = '' } = JSON.parse(localStorage.getItem('user'))
    // if (+onlyAllowRefundOrder === 1) {
    //   this.timer = setInterval(this.judgeMessage, 60000)
    // }
    this.loadNotify()
  },
  destroyed() {
    this.$notify.closeAll()
  },
  methods: {
    async judgeMessage() {
      const { data } = await this.$store.dispatch('orderMessage/collection', {})
      if (data.remind) {
        clearInterval(this.timer)
        this.$notify.info({
          title: '消息',
          duration: 0,
          message: '你有一条退款单需要处理',
          onClose: async () => {
            await this.$store.dispatch('orderMessage/create', {})
            this.timer = setInterval(this.judgeMessage, 180000)
          }
        });
      }
    },
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    async loadNotify() {
      const notifies = await actionClient.get('/notification')
      Object.keys(notifies).forEach(async (item) => {
        let urlName = undefined
        switch (item) {
          case 'after_sale_refund':
            urlName = 'order-refund'
            break
          case 'after_sale_return':
            urlName = 'order-return'
        }
        setTimeout(() => {
          let notify = this.$notify.info({
            ...notifies[item],
            duration: 0,
            offset: 50,
            onClick: () => {
              this.$router.push({ name: urlName })
              notify.close()
            },
          })
        }, 300)
      })
    }
  }
}
</script>

